import { render, staticRenderFns } from "./ReportByAges.vue?vue&type=template&id=399b5f7c&scoped=true"
import script from "./ReportByAges.vue?vue&type=script&lang=js"
export * from "./ReportByAges.vue?vue&type=script&lang=js"
import style0 from "./ReportByAges.vue?vue&type=style&index=0&id=399b5f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399b5f7c",
  null
  
)

export default component.exports